<template>
  <b-modal
    ref="modal"
    :title="`Rapporti utenza ${rowRichiesta.cftitolare}`"
    centered
    body-class="p-0"
    no-close-on-backdrop
  >

    <div
      role="group"
      class="col-12 stack-label"
    >
      <label>Seleziona rapporto utenza</label>

      <!-- Mettere tabella con elenco dei rapporti utenza/BU. -->
      <accesso-ru-table
        :items="itemsRUBU"
        @RUSelected="selectedRU"
      />

    </div>

    <template slot="modal-footer">

      <b-button
        variant="outline-secondary"
        @click="close"
      >
        <font-awesome-icon icon="times" /> Chiudi
      </b-button>
    </template>

  </b-modal>
</template>

<script>
import AccessoRuTable from '@/components/AccessoRapportiUtenzaBUTable'

export default {
  name: 'AccessoRapportiUtenzaBUModal',
  components: {
    AccessoRuTable
  },
  data () {
    return {
      listaRuBu: [],
      tipo: '',
      codiceUib: '',
      codiceUibOptions: {},
      rowRichiesta: {},
      itemsRUBU: []
    }
  },

  methods: {

    async open ({ delegaInfo, RUBUItems }) {
      // Parametri passati sono: codice fiscale titolare
      // Una volta selezionato il codice RU su cui si vuole lavorare va sostituito nella struttura dell'utente corrente.

      this.rowRichiesta = Object.assign({}, delegaInfo)
      this.itemsRUBU = [...RUBUItems]

      // console.log('AccessoRapportiUtenzaBUModal Open', this.rowRichiesta, this.itemsRUBU)

      // Carica elenco delle RU-BU

      this.$refs.modal.show()
    },

    selectedRU (row) {
      // console.log('selectedRU (row)', row)
      this.$emit('accediRUSel', row)
    },

    close () {
      this.$refs.modal.hide()
    },

    async addNew () {
      try {
        let rs = await this.$store.dispatch('istanze/addNew', { tipoIstanza: this.tipo, codiceUib: this.codiceUib })
        this.close()
        this.$router.push({ name: 'istanza', params: { id: rs.id } })
      } catch (err) {
        this.$ui.showError(err)
        // Se c'è qualsiasi tipo di problema nel caricamento della lista delle dichiarazioni esce comunque.
        this.$router.push({ name: 'home' })
      }
    }
  }
}
</script>
